var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00008 4L9.16498 9.7154C9.82618 10.1783 10.1568 10.4097 10.5164 10.4993C10.834 10.5785 11.1662 10.5785 11.4838 10.4993C11.8434 10.4097 12.174 10.1783 12.8352 9.7154L21.0001 4M5.80008 17H16.2001C17.8803 17 18.7203 17 19.3621 16.673C19.9266 16.3854 20.3855 15.9265 20.6731 15.362C21.0001 14.7202 21.0001 13.8802 21.0001 12.2V5.8C21.0001 4.11984 21.0001 3.27976 20.6731 2.63803C20.3855 2.07354 19.9266 1.6146 19.3621 1.32698C18.7203 1 17.8803 1 16.2001 1H5.80008C4.11992 1 3.27984 1 2.63811 1.32698C2.07362 1.6146 1.61468 2.07354 1.32706 2.63803C1.00008 3.27976 1.00008 4.11984 1.00008 5.8V12.2C1.00008 13.8802 1.00008 14.7202 1.32706 15.362C1.61468 15.9265 2.07362 16.3854 2.63811 16.673C3.27984 17 4.11992 17 5.80008 17Z",
    stroke: "#A2750F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e92b385b6b5939f9721f14f6aeaa7f8e.svg";
export { ForwardRef as ReactComponent };